module.exports = __webpack_public_path__ + "static/media/LoyalityProgramCards-2bal.fb7dabce.png";